(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filtres-rayon"] && !Shopify.designMode) return;
  try {
    class RayonFiltres extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-correspondances]');
      try {
        this.valeurs = JSON.parse(source.textContent);
      } catch {
        return;
      }
      this.compte = this.querySelector('[data-compte]');
      this.actifs = this.querySelector('[data-actifs]');
      this.raz = this.querySelector('[data-raz]');
      const bascule = this.querySelector('[data-bascule]');
      bascule?.addEventListener('click', () => {
        bascule.setAttribute('aria-expanded', bascule.getAttribute('aria-expanded') !== 'true');
      });
      this.initCurseur();
      this.suitLaGrille();
      this.addEventListener('change', (evenement) => {
        // Le curseur a son propre gestionnaire : sans ce garde, chaque
        // deplacement appliquerait le filtre deux fois.
        if (evenement.target.type === 'range') return;
        if (evenement.target.closest('[data-cle="prix"]')) this.razCurseur();
        this.applique();
      });
      this.raz?.addEventListener('click', () => {
        this.querySelectorAll('input:checked').forEach((c) => (c.checked = false));
        this.razCurseur();
        this.applique();
      });
    }

    suitLaGrille() {
      // Le rayon charge ses pages suivantes au defilement : les cartes qui
      // arrivent apres coup n'ont jamais vu le filtre et s'affichaient meme
      // quand elles auraient du etre cachees.
      //
      // On surveille la GRILLE, jamais un de ses ancetres. `<results-list>`
      // porte la classe « product-grid-container », si bien que le selecteur
      // large l'accrochait en premier : or il enveloppe AUSSI cette colonne de
      // filtres. Le compte de resultats et le nombre de filtres actifs, que
      // `applique()` ecrit lui-meme, comptaient donc comme des mutations a
      // surveiller et rappelaient `applique()`, qui les reecrivait, toutes les
      // 60 ms sans fin. Rien ne se voyait au repos, parce qu'ecrire une chaine
      // vide dans un noeud deja vide ne mute rien : la boucle demarrait au
      // premier clic et la page ne repondait plus.
      if (typeof MutationObserver === 'undefined') return;
      const grille = this.grille || document.querySelector('.product-grid');
      if (!grille) return;
      let attente = null;
      new MutationObserver((enregistrements) => {
        // Ceinture et bretelles : quoi qu'il arrive a la structure du theme,
        // une mutation qui sort de notre propre colonne ne relance rien.
        if (enregistrements.every((e) => this.contains(e.target))) return;
        clearTimeout(attente);
        attente = setTimeout(() => this.applique(), 60);
      }).observe(grille, { childList: true });
    }

    initCurseur() {
      this.curseur = this.querySelector('[data-curseur]');
      if (!this.curseur) return;
      this.prixMin = this.curseur.querySelector('[data-prix-min]');
      this.prixMax = this.curseur.querySelector('[data-prix-max]');
      this.rail = this.curseur.querySelector('[data-rail]');
      this.afficheMin = this.curseur.querySelector('[data-affiche-min]');
      this.afficheMax = this.curseur.querySelector('[data-affiche-max]');
      this.borneMin = Number(this.curseur.dataset.borneMin);
      this.borneMax = Number(this.curseur.dataset.borneMax);

      const bouge = (source) => {
        let bas = Number(this.prixMin.value);
        let haut = Number(this.prixMax.value);
        // Les deux poignees sont deux champs distincts : sans ce croisement,
        // le minimum peut depasser le maximum et la selection devient vide.
        if (bas > haut) {
          if (source === this.prixMin) bas = haut;
          else haut = bas;
          this.prixMin.value = bas;
          this.prixMax.value = haut;
        }
        // Le curseur prend la main sur les cases de prix : les deux ensemble
        // produiraient des selections vides sans dire pourquoi.
        this.querySelectorAll('[data-cle="prix"] input:checked').forEach((c) => (c.checked = false));
        this.dessineRail();
        this.applique();
      };
      this.prixMin.addEventListener('input', () => bouge(this.prixMin));
      this.prixMax.addEventListener('input', () => bouge(this.prixMax));
      this.dessineRail();
    }

    get grille() {
      const carte = document.querySelector('[class*="product-grid__item"]');
      return carte ? carte.parentElement : null;
    }

    chargeToutesLesPages() {
      // Le rayon ne rend que sa premiere page, les suivantes arrivent au
      // defilement. Des qu'un filtre est pose, la selection peut porter
      // entierement sur des cartes pas encore la : le compte tombait a zero
      // alors que la table en connaissait douze. On tire donc les pages
      // manquantes avec le HTML du theme lui-meme, ce qui evite de redessiner
      // des cartes a la main.
      //
      // Cette fonction n'est PAS `async`, et c'est tout le sujet. Declaree
      // `async`, meme son « rien a tirer » rendait une promesse : `applique()`
      // y lisait « un chargement est en cours », enchainait dessus, se
      // rappelait en micro-tache, redemandait, et ainsi de suite sans jamais
      // rendre la main au navigateur. Un rayon de moins de 50 produits tombe
      // toujours dans ce cas, donc l'onglet se figeait au premier clic.
      //
      // `this.chargement` vaut desormais trois choses distinctes : `undefined`
      // tant qu'on n'a pas regarde, `null` quand il n'y a rien a tirer, une
      // promesse pendant le tirage. Seul `undefined` autorise un nouveau
      // passage, donc la question ne se pose qu'une fois.
      if (this.chargement !== undefined) return this.chargement;
      const grille = this.grille;
      if (!grille) return (this.chargement = null);
      const vus = new Set([...grille.children].map((c) => c.dataset.productId));
      if (vus.size >= Object.keys(this.valeurs).length) return (this.chargement = null);

      this.chargement = (async () => {
        let vides = 0;
        for (let page = 2; page <= 12; page += 1) {
          const url = new URL(location.href);
          url.searchParams.set('page', page);
          let doc;
          try {
            const reponse = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!reponse.ok) break;
            doc = new DOMParser().parseFromString(await reponse.text(), 'text/html');
          } catch {
            break;
          }
          const cartes = [...doc.querySelectorAll('[class*="product-grid__item"]')];
          if (!cartes.length) break;
          let ajoutees = 0;
          cartes.forEach((carte) => {
            const id = carte.dataset.productId;
            // On interroge la grille VIVANTE, jamais un instantane pris au
            // depart : le theme tire lui aussi les pages suivantes au
            // defilement, dans cette meme grille. Un instantane ne voit pas ses
            // insertions, si bien qu'une page arrivait deux fois et que chaque
            // produit s'affichait en double sous un compte qui, lui, restait
            // juste.
            if (!id || grille.querySelector('[data-product-id="' + id + '"]')) return;
            grille.appendChild(carte);
            ajoutees += 1;
          });
          // Une page deja entierement posee par le theme n'ajoute rien, et ce
          // n'est pas une raison d'arreter : la suivante peut manquer. On ne
          // renonce qu'apres deux pages muettes d'affilee.
          vides = ajoutees ? 0 : vides + 1;
          if (vides >= 2) break;
          if (grille.children.length >= Object.keys(this.valeurs).length) break;
        }
      })();
      return this.chargement;
    }

    // Compte de verite : il sort de la table, pas des cartes presentes. Une
    // carte pas encore chargee reste un produit qui correspond.
    compteReel(choix, parPrix, bas, haut) {
      const cles = Object.keys(choix);
      return Object.values(this.valeurs).filter((entree) => {
        const v = entree.f || {};
        if (!cles.every((cle) => choix[cle].includes(v[cle]))) return false;
        if (parPrix) return typeof entree.p === 'number' && entree.p >= bas && entree.p <= haut;
        return true;
      }).length;
    }

    curseurActif() {
      if (!this.curseur) return false;
      return Number(this.prixMin.value) > this.borneMin || Number(this.prixMax.value) < this.borneMax;
    }

    razCurseur() {
      if (!this.curseur) return;
      this.prixMin.value = this.borneMin;
      this.prixMax.value = this.borneMax;
      this.dessineRail();
    }

    dessineRail() {
      if (!this.curseur) return;
      const etendue = this.borneMax - this.borneMin || 1;
      const bas = ((Number(this.prixMin.value) - this.borneMin) / etendue) * 100;
      const haut = ((Number(this.prixMax.value) - this.borneMin) / etendue) * 100;
      this.rail.style.insetInlineStart = bas + '%';
      this.rail.style.inlineSize = haut - bas + '%';
      this.afficheMin.textContent = this.prixMin.value;
      this.afficheMax.textContent = this.prixMax.value;
    }

    get cartes() {
      // La grille est rendue par la section voisine : on la retrouve dans la page.
      return document.querySelectorAll('[class*="product-grid__item"]');
    }

    selection() {
      const choix = {};
      this.querySelectorAll('[data-cle]').forEach((groupe) => {
        const coches = [...groupe.querySelectorAll('input:checked')].map((c) => c.value);
        if (coches.length) choix[groupe.dataset.cle] = coches;
      });
      return choix;
    }

    // Le theme insere ses propres pages au defilement, y compris apres notre
    // chargement : un balayage a chaque passage garantit qu'un produit n'occupe
    // jamais deux cartes, quel que soit l'ordre d'arrivee des deux sources.
    dedoublonne() {
      const grille = this.grille;
      if (!grille) return;
      const vus = new Set();
      [...grille.children].forEach((carte) => {
        const id = carte.dataset.productId;
        if (!id) return;
        if (vus.has(id)) carte.remove();
        else vus.add(id);
      });
    }

    applique() {
      this.dedoublonne();
      const choix = this.selection();
      const parPrix = this.curseurActif();
      if (parPrix) delete choix.prix;
      const cles = Object.keys(choix);
      const bas = parPrix ? Number(this.prixMin.value) : null;
      const haut = parPrix ? Number(this.prixMax.value) : null;
      let visibles = 0;

      this.cartes.forEach((carte) => {
        const lien = carte.querySelector('a[href*="/products/"]');
        const handle = lien ? lien.getAttribute('href').split('/products/')[1].split(/[?#]/)[0] : '';
        const entree = this.valeurs[handle] || {};
        const valeurs = entree.f || {};
        // Entre facettes on cumule les conditions, à l'intérieur d'une facette
        // on additionne les choix : c'est ce qu'attend quelqu'un qui coche
        // « 75 cm » puis « 90 cm ».
        let garde = cles.every((cle) => choix[cle].includes(valeurs[cle]));
        if (garde && parPrix) {
          garde = typeof entree.p === 'number' && entree.p >= bas && entree.p <= haut;
        }
        carte.hidden = !garde;
        if (garde) visibles += 1;
      });

      const filtre = cles.length > 0 || parPrix;
      // Une seule relance, et seulement au tout premier filtre pose. On teste
      // `undefined` et non la verite de `this.chargement` : « rien a tirer »
      // vaut `null`, qui est faux, et rouvrait donc la porte a chaque passage.
      if (filtre && this.chargement === undefined) {
        const chargement = this.chargeToutesLesPages();
        if (chargement) chargement.then(() => this.applique());
      }
      const total = filtre ? this.compteReel(choix, parPrix, bas, haut) : visibles;
      const nb = cles.reduce((t, cle) => t + choix[cle].length, 0) + (parPrix ? 1 : 0);
      // Ecritures idempotentes. Reecrire le meme texte remplace quand meme le
      // noeud, donc compte comme une mutation, et fait re-annoncer la ligne
      // `aria-live` a chaque passage. Passer deux fois de suite ici ne doit
      // rien couter ni rien dire.
      const ecrit = (noeud, texte) => {
        if (noeud && noeud.textContent !== texte) noeud.textContent = texte;
      };
      if (this.actifs) {
        this.actifs.hidden = !filtre;
        ecrit(this.actifs, nb > 0 ? nb + (nb > 1 ? ' actifs' : ' actif') : '');
      }
      this.raz.hidden = !filtre;
      this.compte.hidden = !filtre;
      if (filtre) {
        ecrit(
          this.compte,
          total === 0
            ? 'Aucun produit ne correspond à ces critères.'
            : total + (total > 1 ? ' produits correspondent.' : ' produit correspond.')
        );
      }
    }
  }

  if (!customElements.get('rayon-filtres')) {
    customElements.define('rayon-filtres', RayonFiltres);
  }
  } catch(e) { console.error(e); }
})();

})();
